import { useMailContext } from '../context/MailContext';

/**
 * @deprecated Используйте useMailContext напрямую из MailContext.
 */
export const useMail = () => {
  return useMailContext();
}; 